import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import GridOnIcon from "@mui/icons-material/GridOn";
import DescriptionIcon from "@mui/icons-material/Description";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import SlideshowIcon from "@mui/icons-material/Slideshow";

export const getFileTypeIcon = (extension) => {
  const ext = extension?.toLowerCase();

  const commonStyle = { fontSize: 40 };

  switch (ext) {
    case "pdf":
      return <PictureAsPdfIcon sx={{ ...commonStyle, color: "#E53935" }} />;

    case "xlsx":
    case "xls":
    case "csv":
      return <GridOnIcon sx={{ ...commonStyle, color: "#43A047" }} />;

    case "doc":
    case "docx":
      return <DescriptionIcon sx={{ ...commonStyle, color: "#1E88E5" }} />;

    case "ppt":
    case "pptx":
      return <SlideshowIcon sx={{ ...commonStyle, color: "#FB8C00" }} />;

    default:
      return (
        <InsertDriveFileIcon
          sx={{ ...commonStyle, color: "#757575" }}
        />
      );
  }
};
